// Personel belgesi değişti (onay/red/silme): taşeron sayfasındaki kişi listesi + izin detayındaki personel satırı
// (izin çekmecesi belgeleri bu satırdan okur) + kişiyi gömen HER izin detayı
// (hazırlık §17.2/§22 — kişi birden çok izne bağlı olabilir) + kontrol aşaması detayları yeniden çekilir.
// `vehicleCache.ts`'in personel ikizi; yalnız "bu izni" geçersiz kılmak bayat liste bırakır.
import type { QueryClient } from '@tanstack/react-query';
import { contractorsKeys } from './contractorsKeys';
import { departmentReviewKeys } from './departmentReviewKeys';
import { permitsKeys } from './permitsKeys';

export function invalidatePersonnelDocumentCaches(
  queryClient: QueryClient,
  contractorUuid: string,
  userUuid: string,
) {
  queryClient.invalidateQueries({
    queryKey: contractorsKeys.personnelDocuments(contractorUuid, userUuid),
  });
  queryClient.invalidateQueries({ queryKey: permitsKeys.detailAll() });
  queryClient.invalidateQueries({ queryKey: permitsKeys.list() });
  queryClient.invalidateQueries({ queryKey: departmentReviewKeys.all() });
}
